import { render, staticRenderFns } from "./ModalSterilizareHistory.vue?vue&type=template&id=769d5136"
import script from "./ModalSterilizareHistory.vue?vue&type=script&lang=js"
export * from "./ModalSterilizareHistory.vue?vue&type=script&lang=js"
import style0 from "./ModalSterilizareHistory.vue?vue&type=style&index=0&id=769d5136&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports